var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_vm._v(" "+_vm._s(this.$store.state.xinhuaErrMsg)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }